import React from 'react'
import { BuilderComponent } from "@builder.io/react"
import useGetAllSymbol from '../hooks/useGetAllSymbol'

export default function BrowseCategories() {
    const browseCategories = useGetAllSymbol('MPC Browse Categories')
    if (browseCategories) return (
        <BuilderComponent
            model="symbol"
            content={browseCategories.content}
        />
    )
}